import React from "react";
import { useBackdrop } from "hooks";
import { StyledBackdrop } from "components/BackdropProvider/Backdrop.styled";
import { CircularProgress } from "@material-ui/core";

export const Backdrop: React.FC = () => {
    const { isVisible, hideBackdrop } = useBackdrop();

    return (
        <StyledBackdrop open={isVisible} onClick={hideBackdrop}>
            <CircularProgress color="inherit" />
        </StyledBackdrop>
    );
};
